import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M8.48694 20.031H4.58594C3.76094 20.031 3.08594 19.677 3.08594 18.852V15.748C3.08594 14.923 3.76094 14.248 4.58594 14.248H8.48694C9.31194 14.248 9.98694 14.923 9.98694 15.748V18.852C9.98694 19.677 9.31194 20.031 8.48694 20.031Z"
      fill="currentColor"
    />
    <path
      d="M10.9919 6.01794H8.00794C7.18294 6.01794 6.44594 6.66394 6.08594 7.51794L3.08594 15.4929C3.08594 16.3179 3.76094 18.7449 4.58594 18.7449H8.49194C9.31694 18.7449 9.99194 16.3179 9.99194 15.4929L10.0079 14.0939L10.9919 13.0109V6.01794V6.01794Z"
      fill="currentColor"
    />
    <path d="M10.9919 7.01196H13.0229V11.033H10.9919V7.01196Z" fill="currentColor" />
    <path
      d="M10.1471 7.01196H7.88506C7.41806 7.01196 7.03906 6.63296 7.03906 6.16596V4.85796C7.03906 4.39096 7.41806 4.01196 7.88506 4.01196H10.1471C10.6141 4.01196 10.9931 4.39096 10.9931 4.85796V6.16696C10.9921 6.63396 10.6141 7.01196 10.1471 7.01196Z"
      fill="currentColor"
    />
    <path
      d="M15.4819 20.0311H19.4139C20.2389 20.0311 20.9139 19.3871 20.9139 18.5621V15.8521C20.9139 15.0271 20.2389 14.3521 19.4139 14.3521H15.4819C14.6569 14.3521 13.9819 15.0271 13.9819 15.8521V18.5621C13.9819 19.3881 14.6569 20.0311 15.4819 20.0311V20.0311Z"
      fill="currentColor"
    />
    <path
      d="M13.0081 5.99805H15.9921C16.8171 5.99805 17.5541 6.64405 17.9141 7.49805L20.9141 15.473C20.9141 16.298 20.2391 18.621 19.4141 18.621H15.5081C14.6831 18.621 14.0081 16.298 14.0081 15.473L13.9921 14.074L13.0081 12.991V5.99805V5.99805Z"
      fill="currentColor"
    />
    <path
      d="M13.8531 6.99197H16.1151C16.5821 6.99197 16.9611 6.61297 16.9611 6.14597V4.83697C16.9611 4.36997 16.5821 3.99097 16.1151 3.99097H13.8531C13.3861 3.99097 13.0071 4.36997 13.0071 4.83697V6.14597C13.0081 6.61297 13.3861 6.99197 13.8531 6.99197Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'BinocularsFill');

export default Icon;
